import React from 'react';
import {
  LayoutDashboard,
  Package,
  FileText,
  Mic,
  Archive,
  MessageSquare,
  Globe,
  Users,
  LogOut,
  X,
  Phone,
  Wrench,
  Briefcase,
  Headphones
} from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const menuItems = [
  { text: 'Dashboard', icon: LayoutDashboard, path: '/dashboard', disabled: false },
  { text: 'Ürünler & Kategoriler', icon: Package, path: '/products', disabled: false },
  { text: 'Hizmetler', icon: Wrench, path: '/services', disabled: false },
  { text: 'Blog', icon: FileText, path: '/blog', disabled: false },
  { text: 'Podcast', icon: Mic, path: '/podcast', disabled: false },
  { text: 'Kaynaklar', icon: Archive, path: '/resources', disabled: false },
  { text: 'Kariyer', icon: Briefcase, path: '/career', disabled: false },
  { text: 'Destek Ekibi', icon: Headphones, path: '/support', disabled: false },
  { text: 'RFQ Talepleri', icon: MessageSquare, path: '/rfq', disabled: true },
  { text: 'Şirket Bilgileri', icon: Phone, path: '/contact', disabled: true },
  { text: 'Sayfa Yönetimi', icon: Globe, path: '/pages', disabled: true },
  { text: 'Kullanıcılar', icon: Users, path: '/users', disabled: true },
];

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    // TODO: Implement logout logic
    navigate('/login');
  };

  const SidebarContent = () => (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div className="p-6 border-b border-gray-200">
        <h1 className="text-xl font-bold text-gray-800">ZPC Admin Panel</h1>
      </div>
      
      {/* Menu Items */}
      <div className="flex-1 overflow-y-auto py-4">
        <nav className="space-y-1 px-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <button
                key={item.text}
                onClick={() => !item.disabled && handleNavigation(item.path)}
                disabled={item.disabled}
                className={`w-full flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  item.disabled
                    ? 'text-gray-400 cursor-not-allowed opacity-50'
                    : isActive
                    ? 'bg-primary-50 text-primary-600 border-r-2 border-primary-600'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-primary-600'
                }`}
              >
                <Icon className="mr-3 h-5 w-5" />
                {item.text}
                {item.disabled && (
                  <span className="ml-auto text-xs bg-gray-200 text-gray-500 px-2 py-1 rounded-full">
                    Yakında
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Logout Button */}
      <div className="border-t border-gray-200 p-4">
        <button
          onClick={handleLogout}
          className="w-full flex items-center px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-red-600 rounded-lg transition-colors duration-200"
        >
          <LogOut className="mr-3 h-5 w-5" />
          Çıkış Yap
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile Sidebar */}
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
          <div className="fixed inset-y-0 left-0 w-80 bg-white shadow-xl">
            <div className="absolute top-0 right-0 p-4">
              <button
                onClick={onClose}
                className="p-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <SidebarContent />
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:w-80 lg:flex-col lg:fixed lg:inset-y-0">
        <SidebarContent />
      </div>
    </>
  );
};

export default Sidebar;

